export const buildShopifyOnboardingUrl = (shopifyOrderId: string, email: string, region = 'eu'): string => {
  const encodedEmail = encodeURIComponent(email);

  return `https://app.self.co/${region}/en/questionnaire/shopify/${shopifyOrderId}?email=${encodedEmail}`;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);

    return true;
  } catch {
    return false;
  }
};
